'use client';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../ProductCard/ProductCard';
import { getProducts } from '../../services/productService';
import './ShopSection.css';

const ShopSection = ({ initialProducts }) => {
  const [products, setProducts] = useState(
    initialProducts && initialProducts.length > 0 ? initialProducts.slice(0, 12) : []
  );
  const [isHovered, setIsHovered] = useState(false);
  const scrollContainerRef = useRef(null);
  const autoScrollIntervalRef = useRef(null);

  const fetchProducts = useCallback(async () => {
    if (initialProducts && initialProducts.length > 0) return;
    try {
      const result = await getProducts({ newArrival: true, limit: 12 });
      let fetchedProducts = result.products || [];

      // Filter new arrivals or fallback to all products
      const newArrivals = fetchedProducts.filter(p => p.newArrival);
      const displayList = newArrivals.length > 0 ? newArrivals : fetchedProducts;
      setProducts(displayList.slice(0, 12));
    } catch (error) {
      console.error('Error fetching new arrival products from Firestore:', error);
      setProducts([]);
    }
  }, [initialProducts]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // Auto-scroll functionality
  useEffect(() => {
    if (products.length === 0 || isHovered) return;

    autoScrollIntervalRef.current = setInterval(() => {
      if (scrollContainerRef.current) {
        const container = scrollContainerRef.current;
        const scrollAmount = 320;
        const maxScroll = container.scrollWidth - container.clientWidth;
        
        if (container.scrollLeft >= maxScroll - 10) {
          // Reset to beginning when reaching the end
          container.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else {
          container.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        }
      }
    }, 3000); // Auto-scroll every 3 seconds

    return () => {
      if (autoScrollIntervalRef.current) {
        clearInterval(autoScrollIntervalRef.current);
      }
    };
  }, [products, isHovered]);

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 320,
        behavior: 'smooth'
      });
    }
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -320,
        behavior: 'smooth'
      });
    }
  };

  // Ensure products is always an array
  const safeProducts = Array.isArray(products) ? products : [];

  return (
    <section className="shop-section">
      <h2 className="common-heading center">New Arrival</h2>
      <div 
        className="shop-section-container"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="shop-images-section" ref={scrollContainerRef}>
        {safeProducts.map((product) => (
            <ProductCard key={product._id || product.id} product={product} showNewBadge={true} />
        ))}
        </div>
      </div>
      <div className="shop-section-footer">
        <Link to="/shop?filter=newArrival" className="view-all-btn">
          VIEW ALL
        </Link>
      </div>
    </section>
  );
};

export default ShopSection;